module.exports = __webpack_public_path__ + "static/media/Razor.00ba2a22.png";